// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Nav Styles */
.gapsy-navbar_stickyNav__2jfyB {
  position: sticky;
  top: 56px;
  z-index: 1020;
  background-color: #366872;
  color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.gapsy-navbar_navLink__s9Ck1 {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: white;
}

.gapsy-navbar_active__kPrzc.gapsy-navbar_navLink__s9Ck1 {
  color: #ffd166;
  padding: 6px 10px;
  text-decoration: none;
}

.gapsy-navbar_navLinkDefault__BMWlz {
  padding: 6px 10px;
  text-decoration: none;
}

/* Dropdown Menu Styling */
.gapsy-navbar_dropdownMenuStyled__aEuzM {
  background-color: #366872;
  color: #fff;
  border: none;
}

.gapsy-navbar_dropdownMenuStyled__aEuzM a,
.gapsy-navbar_dropdownMenuStyled__aEuzM i {
  color: #fff !important;
}

li.gapsy-navbar_navItem__peqzd a {
  font-size: 12px !important;
}

.gapsy-navbar_dropdownMenuStyled__aEuzM {
  min-width: 200px;
}

.gapsy-navbar_dropdownItem__if\\+dy {
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  color: #212529;
}

.gapsy-navbar_dropdownItem__if\\+dy:hover {
  background-color: #f8f9fa;
}

/* Submenu Dropdown */
.gapsy-navbar_dropdownSubmenu__Z7kub {
  position: relative;
}

.gapsy-navbar_dropdownItem__if\\+dy {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.gapsy-navbar_submenu__x342z {
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  margin-top: -0.125rem;
  min-width: 120px;
  z-index: 1050;
}

.gapsy-navbar_dropdownSubmenu__Z7kub:hover .gapsy-navbar_submenu__x342z {
  display: block;
}

.gapsy-navbar_dropdownMenu__Q0IN5 .gapsy-navbar_dropdownItem__if\\+dy i {
  color: #6c757d;
}

.gapsy-navbar_dropdownSubmenu__Z7kub .gapsy-navbar_dropdownItem__if\\+dy i {
  color: #6c757d;
}

.gapsy-navbar_dropdownMenu__Q0IN5 .gapsy-navbar_dropdownItem__if\\+dy:hover {
  background-color: #ccc;
}

.gapsy-navbar_dropdownSubmenu__Z7kub .gapsy-navbar_dropdownItem__if\\+dy:hover {
  background-color: #ccc;
}

.gapsy-navbar_dropdownSubmenu__Z7kub .gapsy-navbar_dropdownItem__if\\+dy {
  color: #fff !important;
}

button.gapsy-navbar_dropdownItem__if\\+dy {
  font-size: 12px;
}

a.gapsy-navbar_dropdownItem__if\\+dy,
.gapsy-navbar_dropdown-adjustables__febJ5 {
  font-size: 12px;
}

.gapsy-navbar_active__kPrzc.gapsy-navbar_navLink__s9Ck1 {
  color: #ffd166;
  padding: 6px 10px;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsy-navbar.module.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB","sourcesContent":["/* Main Nav Styles */\r\n.stickyNav {\r\n  position: sticky;\r\n  top: 56px;\r\n  z-index: 1020;\r\n  background-color: #366872;\r\n  color: white;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.navLink {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  color: white;\r\n}\r\n\r\n.active.navLink {\r\n  color: #ffd166;\r\n  padding: 6px 10px;\r\n  text-decoration: none;\r\n}\r\n\r\n.navLinkDefault {\r\n  padding: 6px 10px;\r\n  text-decoration: none;\r\n}\r\n\r\n/* Dropdown Menu Styling */\r\n.dropdownMenuStyled {\r\n  background-color: #366872;\r\n  color: #fff;\r\n  border: none;\r\n}\r\n\r\n.dropdownMenuStyled a,\r\n.dropdownMenuStyled i {\r\n  color: #fff !important;\r\n}\r\n\r\nli.navItem a {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.dropdownMenuStyled {\r\n  min-width: 200px;\r\n}\r\n\r\n.dropdownItem {\r\n  font-size: 0.875rem;\r\n  padding: 0.5rem 1rem;\r\n  color: #212529;\r\n}\r\n\r\n.dropdownItem:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n/* Submenu Dropdown */\r\n.dropdownSubmenu {\r\n  position: relative;\r\n}\r\n\r\n.dropdownItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.submenu {\r\n  display: none;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 100%;\r\n  margin-top: -0.125rem;\r\n  min-width: 120px;\r\n  z-index: 1050;\r\n}\r\n\r\n.dropdownSubmenu:hover .submenu {\r\n  display: block;\r\n}\r\n\r\n.dropdownMenu .dropdownItem i {\r\n  color: #6c757d;\r\n}\r\n\r\n.dropdownSubmenu .dropdownItem i {\r\n  color: #6c757d;\r\n}\r\n\r\n.dropdownMenu .dropdownItem:hover {\r\n  background-color: #ccc;\r\n}\r\n\r\n.dropdownSubmenu .dropdownItem:hover {\r\n  background-color: #ccc;\r\n}\r\n\r\n.dropdownSubmenu .dropdownItem {\r\n  color: #fff !important;\r\n}\r\n\r\nbutton.dropdownItem {\r\n  font-size: 12px;\r\n}\r\n\r\na.dropdownItem,\r\n.dropdown-adjustables {\r\n  font-size: 12px;\r\n}\r\n\r\n.active.navLink {\r\n  color: #ffd166;\r\n  padding: 6px 10px;\r\n  text-decoration: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stickyNav": `gapsy-navbar_stickyNav__2jfyB`,
	"navLink": `gapsy-navbar_navLink__s9Ck1`,
	"active": `gapsy-navbar_active__kPrzc`,
	"navLinkDefault": `gapsy-navbar_navLinkDefault__BMWlz`,
	"dropdownMenuStyled": `gapsy-navbar_dropdownMenuStyled__aEuzM`,
	"navItem": `gapsy-navbar_navItem__peqzd`,
	"dropdownItem": `gapsy-navbar_dropdownItem__if+dy`,
	"dropdownSubmenu": `gapsy-navbar_dropdownSubmenu__Z7kub`,
	"submenu": `gapsy-navbar_submenu__x342z`,
	"dropdownMenu": `gapsy-navbar_dropdownMenu__Q0IN5`,
	"dropdown-adjustables": `gapsy-navbar_dropdown-adjustables__febJ5`
};
export default ___CSS_LOADER_EXPORT___;
